import React, { useState, useEffect } from 'react';
import PostByAgg from '../../utils/axios';
import classNames from 'classnames';

const FILTER_OPTIONS = [
    { Song: 'All', value: '0', interval_day: 0 },
    { Song: 'Last 7 Day', value: '7day', interval_day: 7 },
    { Song: 'Last 1 Month', value: '1month', interval_day: 30 },
    { Song: 'Last 3 Month', value: '3month', interval_day: 90 }
];

const TopFourLabel = () => {
    const [activeFilter, setActiveFilter] = useState(FILTER_OPTIONS[0]);
    const [labelData, setLabelData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchTopLabels(activeFilter.interval_day);
    }, [activeFilter]);

    const fetchTopLabels = (intervalDay) => {
        setLoading(true);
        PostByAgg({
            url: 'song/v1/track/top-four-labels',
            body: {
                interval_day: intervalDay,
                music_label_code: ''
            },
            onResponse: (res) => {
                console.log('API result Labels:', res);
                setLabelData(Array.isArray(res.data.data) ? res.data.data : []);
                setLoading(false);
            },
            onError: () => {
                setLabelData([]);
                setLoading(false);
            }
        });
    };

    return (
        <div className="col-12">
            <div className="mb-16 mt-8 d-flex flex-wrap justify-content-between gap-16">
                <h6 className="mb-0">Top 4 Labels</h6>
                <ul className="nav button-tab nav-pills mb-16 gap-12" role="tablist">
                    {FILTER_OPTIONS.map((opt) => (
                        <li key={opt.value} className="nav-item" role="presentation">
                            <button
                                className={classNames(
                                    'nav-link fw-semibold text-secondary-light rounded-pill px-20 py-6 border border-neutral-300',
                                    { active: activeFilter.value === opt.value }
                                )}
                                type="button"
                                onClick={() => setActiveFilter(opt)}
                            >
                                {opt.Song}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>

            {loading ? (
                <div className="text-center">Loading...</div>
            ) : (
                <div className="row g-3">
                    {labelData.length > 0 ? labelData.map((item, index) => (
                        <div key={index} className="col-xxl-3 col-sm-6 col-xs-6">
                            <div className="nft-card bg-base radius-16 overflow-hidden">
                                <div className="radius-16 overflow-hidden" style={{ height: '180px' }}>
                                    <img
                                        src={item.image_url}
                                        alt={item.release_name}
                                        className="w-100 h-100 object-fit-cover"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = 'https://www.shutterstock.com/shutterstock/videos/1106390253/thumb/1.jpg?ip=x480';
                                        }}
                                    />
                                </div>
                                <div className="p-10">
                                    <h6 className="text-md fw-bold text-primary-light">
                                        {item.song_title}
                                    </h6>
                                    <div className="mt-10">
                                        <span className="text-sm text-secondary-light fw-medium">
                                            <span className="fw-semibold">{item.music_label_name}</span>
                                        </span>
                                    </div>
                                    <div className="mt-10">
                                        <span className="text-sm text-secondary-light fw-medium">
                                            <span className="fw-semibold">{item.release_name}</span>
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center gap-8 mt-10">
                                        <img
                                            /*
                                            src="http://app.redrobot.co.id/assets/images/ORBIT2crop.png"
                                            */
                                            src="/assets/images/ORBIT2crop.png"
                                            className="w-28-px h-28-px rounded-circle object-fit-cover"
                                            alt="avatar placeholder"
                                        />
                                        <span className="text-sm text-secondary-light fw-medium">
                                            Viewer: {item.viewer}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )) : (
                        <div className="text-center w-100">No data available</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default TopFourLabel;
